<template>
	<div>
		<div class="header">
			<h3 style="padding-left: 20px">
				审核列表
				<span>
					{{ data.length ? `(超过${data[0].timeSize}分钟未审核，系统将自动审核通过。)` : '' }}
				</span>
			</h3>
			<el-button @click="refresh" type="primary" size="small" plain>刷新</el-button>
		</div>
		<filter-panel ref="filterPanel" :data="groups" @search="filterChange"></filter-panel>
		<data-list
			:data="data"
			:columns="column"
			:page="page"
			:page-size="page.pageSize"
			:loading="loading"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>
		<!-- 标签 -->
		<dialog-form
			:dialogVisible="showDoalog"
			:attributes="attributes"
			:formData="formData"
			@close:dialogVisible="val => (showDoalog = val)"
			@confirm="confirm"
		></dialog-form>
		<!-- 审核/查看 -->
		<audit-dialog
			ref="auditDialog"
			:showDialog="dialogVisible"
			:enquiryDetail="enquiryDetail"
			:formGroup="formGroup"
			:detailBtnList="detailBtnList"
			:formBtnList="formBtnList"
			:showPass="showPass"
			:butLoading="auditDialogButLoading"
			@close:dialogVisible="close"
		></audit-dialog>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
import enquiry from '@/backend/services/enquiry/enquiry.js';
import Router from '@/backend/router';
import Status from './status';
import dialogForm from '@/components/dialogForm/dialogForm.vue';
import { validRequired } from '@/common/elementValid.js';
import {
	inquirysource,
	systemFilterType,
	reviewType,
	passMap,
	statusMap,
} from '@/common/dictionary.js';
import auditDialog from '@/backend/pages/audit/auditDialog.vue';
import { getDict } from '@/backend/services/dictionary/dictionary.js';

const list = listPageCreate({
	searchConfig: {
		api: api.inquiry.inquiryList,
		method: 'POST',
	},
	getQuery(obj, that) {
		let id = that.$route.query.id;
		let type = that.$route.query.type;
		if (type != null) {
			that.groups.multiples[0].value = 4;
		}
		return _.assign(obj, {
			ruleId: id || '',
		});
	},
	afterResponse(res, that) {
		if (!that.timeout) {
			that.delayQuery();
		}

		if (res && res.status === 403) {
			Router.push('/');
		} else {
			return res;
		}
	},
});

export default {
	components: {
		filterPanel,
		dialogForm,
		auditDialog,
	},
	mixins: [list],
	data() {
		const groups = {
			multiples: [
				{
					defaultText: '询盘审核状态',
					placeholder: '询盘审核状态',
					label: '询盘审核状态',
					disableClose: true,
					options: statusMap,
					prop: 'type',
					value: 0,
				},
				{
					defaultText: '询盘类型',
					placeholder: '询盘类型',
					label: '询盘类型',
					options: inquirysource,
					prop: 'inquiryType',
					value: '',
				},
				{
					defaultText: '系统过滤类型',
					placeholder: '系统过滤类型',
					label: '系统过滤类型',
					options: systemFilterType,
					prop: 'filterType',
					value: '',
				},
				{
					defaultText: '复查类型',
					placeholder: '复查类型',
					label: '复查类型',
					options: reviewType,
					prop: 'reviewType',
					value: '',
				},
			],
		};
		const column = [
			{
				label: '',
				width: 20,
			},
			{
				label: '标题',
				bind: 'title',
				minWidth: 200,
				showHover: true,
			},
			{
				label: '公司名称',
				bind: 'customerName',
				showHover: true,
			},
			{
				label: '收件人邮箱',
				bind: 'recipientEmail',
				showOverflowTooltip: true,
			},
			{
				label: '发件人邮箱',
				bind: 'senderEmail',
				showOverflowTooltip: true,
			},
			{
				label: '收件时间',
				bind: 'sendTime',
				width: 160,
			},
			{
				label: '审核剩余时间',
				bind: 'auditSurplusTime',
			},
			{
				label: '审核时间',
				bind: 'auditTime',
				width: 180,
			},
			{
				label: '询盘类型',
				bind: 'inquiryType',
				type: 'percentage',
				dataStyle(val) {
					if (val == 1 || val == 4) {
						return '表单询盘';
					}
					if (val == 2) {
						return '邮件询盘';
					}
					if (val == 3) {
						return '社媒询盘';
					}
					if (val == 5) {
						return 'Messenger询盘';
					}
					if (val == 6) {
						return '手动录入';
					}
					if (val == 7) {
						return 'FB表单询盘';
					}
				},
			},
			{
				label: '系统过滤类型',
				bind: 'filterType',
				type: 'percentage',
				dataStyle(val) {
					switch (val) {
						case 1:
							return '邮件过滤';
						case 2:
							return '内容过滤';
						case 3:
							return '关键词过滤';
						default:
							return '-';
					}
				},
			},
			{
				label: '标签',
				bind: 'label',
				showOverflowTooltip: true,
			},
			{
				label: '状态',
				type: Status,
				bind(row) {
					let val = statusMap.find(item => item.value == row.type);
					if (val) {
						return val.label;
					} else {
						return '';
					}
				},
				status(row) {
					let val = statusMap.find(item => item.value == row.type);
					if (val) {
						return val.status;
					} else {
						return 'primary';
					}
				},
			},
			{
				label: '过滤备注',
				bind: 'filterRemarks',
				showOverflowTooltip: true,
			},
			{
				label: '操作',
				type: 'btnClick',
				align: 'center',
				style: 'text',
				width: '140',
				bind: row => {
					if (row.type === 0 || row.type === -99) {
						return [
							{
								text: '审核',
								trigger: async row => {
									let { data } = await enquiry.getInquiryDetail({
										id: row.id,
										inquiryType: row.inquiryType,
									});
									this.enquiryDetail = { ...data, ...row };
									this.setDialogConfig('shenhe');
								},
							},
						];
					} else if (row.type === 1) {
						return [
							{
								text: '查看',
								trigger: async row => {
									let { data } = await enquiry.getInquiryDetail({
										id: row.id,
										inquiryType: row.inquiryType,
									});
									this.enquiryDetail = { ...data, ...row };
									this.setDialogConfig('chakan');
								},
							},
							{
								text: '标签',
								trigger: async row => {
									this.showDoalog = true;
									this.activeData = row;
								},
							},
						];
					} else {
						return [
							{
								text: '查看',
								trigger: async row => {
									let { data } = await enquiry.getInquiryDetail({
										id: row.id,
										inquiryType: row.inquiryType,
									});
									this.enquiryDetail = { ...data, ...row };
									this.setDialogConfig('noGrable');
								},
							},
						];
					}
				},
			},
		];
		const formData = {
			label: {
				label: '标签内容',
				formType: 'sky-textarea',
				autoSize: { minROws: 2 },
				value: '',
				rules: [validRequired('此项必填')],
			},
		};
		return {
			enquiryDetail: {},
			groups: groups,
			column: column,
			inquiryExportParam: {
				domianName: '',
				inquiryType: '',
				sitePlatform: '',
				beginTimeStr: '',
				endTimeStr: '',
			},
			dialogLoading: false,
			auditDialogButLoading: false,
			dialogVisible: false,
			auditType: null,
			showDoalog: false,
			attributes: {
				title: '添加标签',
			},
			formData: formData,
			activeData: {},
			formGroup: {},
			showPass: false, //  审核不通过
			detailBtnList: [],
			formBtnList: [],
			refuseMap: [],
			auditStatus: '',
		};
	},
	mounted() {
		this.query();
		this.getDict();
	},
	methods: {
		// 延迟请求
		delayQuery() {
			this.timeout = setTimeout(() => {
				this.query();
				clearTimeout(this.timeout);
				this.timeout = undefined;
			}, 30000);
		},

		// 配置模态框
		setDialogConfig(type) {
			let btnList = this[`set${type}`]();
			this.detailBtnList = btnList.detail;
			this.formBtnList = btnList.form;
			this.dialogVisible = true;
		},
		// 审核按钮
		setshenhe() {
			let that = this;
			return {
				detail: [
					{
						name: '关闭',
						attributes: {},
						btnClick() {
							that.close();
						},
					},
					{
						name: '审核不通过',
						attributes: {
							type: 'danger',
						},
						btnClick() {
							that.setFormGroups('refuse');
							that.auditStatus = 'refuse';
							that.showPass = true;
						},
					},
					{
						name: '审核通过',
						attributes: {
							type: 'primary',
						},
						btnClick() {
							that.setFormGroups('pass');
							that.auditStatus = 'pass';
							that.showPass = true;
						},
					},
				],
				form: [
					{
						name: '取消',
						attributes: {},
						btnClick() {
							that.showPass = false;
						},
					},
					{
						name: '确定',
						attributes: {
							type: 'primary',
						},
						btnClick() {
							if (that.auditStatus === 'pass') {
								// 审核通过
								that.submit();
							} else {
								// 审核不通过
								that.auditDialog('audit');
							}
						},
					},
				],
			};
		},
		// 非垃圾询盘按钮
		setnoGrable() {
			let that = this;
			let { enquiryDetail } = that;
			return {
				detail: [
					{
						name: '关闭',
						attributes: {},
						btnClick() {
							that.close();
						},
					},
					{
						name: '非垃圾询盘',
						hideBtn: enquiryDetail.type !== 4,
						attributes: {
							type: 'primary',
						},
						btnClick() {
							that.cancellationFilter();
						},
					},
				],
			};
		},
		// 查看按钮
		setchakan() {
			let that = this;
			let { enquiryDetail } = this;
			let btnName = enquiryDetail.reviewType === 2 ? '不通过原因' : '审核不通过';
			let recheck = enquiryDetail.reviewType !== 0 ? '下一封' : '确定，下一封';
			return {
				detail: [
					{
						name: '关闭',
						attributes: {},
						btnClick() {
							that.close();
						},
					},
					{
						name: '复制内容',
						attributes: {
							type: 'primary',
						},
						btnClick() {
							let { enquiryDetail } = that;

							let data =
								enquiryDetail.contentHtml ||
								enquiryDetail.content ||
								enquiryDetail.fbChatRecordShowVO;
							that.$copyText(data).then(
								function () {
									that.$message.success('复制成功');
								},
								function () {
									that.$message.warn('复制失败');
								}
							);
						},
					},
					{
						name: btnName,
						headBtn: enquiryDetail.reviewType === 1,
						attributes: {
							type: 'danger',
						},
						btnClick() {
							that.setFormGroups('refuse');
							that.showPass = true;
						},
					},
					{
						name: '下一封',
						attributes: {
							type: 'primary',
						},
						btnClick() {
							that.auditPass();
						},
					},
				],
				form: [
					{
						name: '取消',
						attributes: {},
						btnClick() {
							that.showPass = false;
						},
					},
					{
						name: recheck,
						attributes: {
							type: 'primary',
						},
						btnClick() {
							that.auditDialog('recheck');
						},
					},
				],
			};
		},
		// 配置form
		setFormGroups(type) {
			let that = this;
			let { enquiryDetail: obj, refuseMap } = this;
			obj = obj.inquiryReviewFailVO || {};
			let { keywordFlag, emailFlag, contentFlag } = obj;
			let checkbox = [];
			keywordFlag === 1 && checkbox.push('key');
			emailFlag === 1 && checkbox.push('email');
			contentFlag === 1 && checkbox.push('content');
			let disabled = this.enquiryDetail.reviewType !== 0;

			let map = {
				refuse: '不通过',
				pass: '通过',
				refuseMap: refuseMap,
				passMap: passMap,
			};
			this.formGroup = {
				dictionaryCode: {
					formType: 'sky-select',
					title: `${map[type]}原因`,
					placeholder: `请选择${map[type]}原因`,
					options: map[`${type}Map`],
					props: {
						label: 'name',
						value: 'code',
					},
					value: obj.dictionaryCode,
					disabled: disabled,
					rules: [validRequired('此项必填', 'change')],
				},
				checkbox: {
					formType: 'sky-checkbox',
					options: [
						{
							label: '加入关键词黑名单',
							value: 'key',
						},
						{
							label: '加入垃圾邮箱黑名单',
							value: 'email',
						},
						{
							label: '加入垃圾内容黑名单',
							value: 'content',
						},
					],
					value: checkbox || [],
					disabled: disabled,
					change() {
						that.$refs.auditDialog.clearValidate(['keywords.value']);
					},
					displayWith() {
						return type === 'refuse';
					},
				},
				keywords: {
					formType: 'sky-input',
					placeholder: '请输入加入黑名单的关键词，多个词请用英文"|"分割',
					value: obj.keywords,
					disabled: disabled,
					rules: [validRequired('此项必填')],
					displayWith(formGroups) {
						return type === 'refuse' && formGroups.checkbox.value.indexOf('key') !== -1;
					},
				},
				remarks: {
					formType: 'sky-input',
					inputType: 'textarea',
					autosize: { minRows: 2 },
					placeholder: '请输入备注',
					value: obj.remarks,
					disabled: disabled,
				},
			};
		},
		// 复制内容
		onCopy() {
			this.$message({
				message: '复制到剪切板成功',
				type: 'success',
				duration: 1500,
			});
		},
		// 确定，下一封
		async auditDialog(type) {
			try {
				// 必填校验
				let refsVal = this.$refs.auditDialog.validate();
				if (!refsVal) {
					this.$message.info('请输入必填内容');
					return false;
				}
				let data = {};
				Object.keys(this.formGroup).forEach(key => {
					data[key] = this.formGroup[key].value;
				});

				let keywordFlag = data.checkbox.indexOf('key') !== -1 ? 1 : 0;
				let emailFlag = data.checkbox.indexOf('email') !== -1 ? 1 : 0;
				let contentFlag = data.checkbox.indexOf('content') !== -1 ? 1 : 0;
				delete data.checkbox;

				let api = {
					recheck: enquiry.reviewfail,
					audit: enquiry.auditPass,
				};
				if (this.enquiryDetail.reviewType === 0 || type === 'audit') {
					await api[type]({
						inquiryId: this.enquiryDetail.id,
						inquiryType: this.enquiryDetail.inquiryType,
						keywordFlag,
						emailFlag,
						contentFlag,
						...data,
					});
					this.$message.success('更新状态成功');
				}
				if (type === 'audit') this.close();
				if (type === 'recheck') {
					await this.nextPage();
					this.showPass = false;
				}
			} catch (error) {
				this.$message.info('更新状态失败');
				this.showPass = true;
			}
		},
		// 关闭
		close(val = false) {
			let { groups } = this;
			let v1 = this.$refs.filterPanel.filterVal(groups);
			this.filterValChange(v1);
			this.dialogVisible = val;
			this.showPass = false;
		},
		// 字典数据
		async getDict() {
			let res = await getDict(300);
			this.refuseMap = res.data || [];
		},
		// 提交
		async submit() {
			try {
				// 必填校验
				let refsVal = this.$refs.auditDialog.validate();
				if (!refsVal) {
					this.$message.info('请输入必填内容');
					return false;
				}
				let data = {};
				Object.keys(this.formGroup).forEach(key => {
					data[key] = this.formGroup[key].value;
				});
				let { dictionaryCode, remarks } = data;
				let { id, inquiryType } = this.enquiryDetail;
				await enquiry.checkInquiry({
					id,
					type: 1,
					auditType: dictionaryCode,
					remarks: remarks,
					inquiryType,
				});
				this.close();
				this.$message.success('更新状态成功');
			} catch (error) {
				this.$message.info('更新状态失败');
				this.dialogVisible = true;
			}
		},
		// 复审通过
		async auditPass() {
			try {
				let { id, inquiryType, reviewType } = this.enquiryDetail;
				if (reviewType === 0) {
					await enquiry.reviewadopt({
						id,
						inquiryType,
					});
					this.$message.success('更新状态成功');
				}
				await this.nextPage();
			} catch (error) {
				this.$message.info('更新状态失败');
			}
		},
		// 请求下一页数据
		async nextPage() {
			let oldIndex;
			this.data.forEach((item, index) => {
				if (item.id === this.enquiryDetail.id) oldIndex = index;
			});
			if (oldIndex === this.data.length - 1) {
				this.$message.info('没有更多数据，请切换下一页');
				this.close();
				return false;
			}
			let { id, inquiryType } = this.data[oldIndex + 1];

			let { data } = await enquiry.getInquiryDetail({
				id,
				inquiryType,
			});
			this.enquiryDetail = { ...data, ...this.data[oldIndex + 1] };
			this.setDialogConfig('chakan');
		},
		// 刷新
		refresh() {
			this.query();
		},
		// 添加标签
		async confirm(cb) {
			let { id, inquiryType } = this.activeData;
			let label = this.formData.label.value;
			let res = await enquiry.addInquiryLabel({
				id,
				label,
				inquiryType,
			});
			if (res.status === 200) {
				this.$message.success('添加成功');
				this.activeData = {};
				this.query();
				cb();
			}
		},
		// 非垃圾询盘
		async cancellationFilter() {
			try {
				this.dialogLoading = true;
				this.auditDialogButLoading = true;
				let { id, inquiryType } = this.enquiryDetail;
				// 记录操作数据
				let res = await enquiry.cancellationFilter({
					id,
					inquiryType,
				});
				if (res.status === 200) {
					this.$message.success('操作成功');
					this.query();
					this.dialogVisible = false;
				}
				this.dialogLoading = false;
				this.auditDialogButLoading = false;
			} catch (err) {
				this.dialogLoading = false;
				this.auditDialogButLoading = false;
			}
		},
	},
};
</script>

<style scoped lang="scss">
.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 10px;

	.el-button {
		height: 32px;
	}
}
</style>
